import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnGegevens = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FED27A"
      d="M32.82 10H7.18A2.18 2.18 0 0 0 5 12.18v15.64A2.18 2.18 0 0 0 7.18 30h25.64A2.18 2.18 0 0 0 35 27.82V12.18A2.18 2.18 0 0 0 32.82 10"
    />
    <path
      fill="#F18700"
      d="M11.96 22.68a4.82 4.82 0 1 0 0-9.64 4.82 4.82 0 0 0 0 9.64"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M7.14 27.5c0-2.66 2.16-4.82 4.82-4.82s4.82 2.16 4.82 4.82z"
      clipRule="evenodd"
    />
    <path
      fill="#F18700"
      d="M32.86 14.14H20v1h12.86zM32.86 17.36H20v1h12.86zM28.86 20.57H20v1h8.86z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnGegevens);

export default ForwardRef;
